import React from 'react';
import { HeroSection } from './HeroSection';
import { WhoThisIsFor } from './WhoThisIsFor';
import { BedtimeDread } from './BedtimeDread';
import { WhyAdviceFails } from './WhyAdviceFails';
import { StabilizationLadder } from './StabilizationLadder';
import { WhatYouGet } from './WhatYouGet';
import { WhatChanges } from './WhatChanges';
import { QuietPromise } from './QuietPromise';
import { FAQSection } from './FAQSection';
import { CTASection } from './CTASection';
import { Footer } from './Footer';
import { FloatingCTA } from './FloatingCTA';
export function SalesPage({
  onNavigate
}: {
  onNavigate: (page: 'terms' | 'privacy') => void;
}) {
  return <div className="min-h-screen bg-white font-sans text-text-body" data-id="element-106">
      <HeroSection data-id="element-107" />
      <WhoThisIsFor data-id="element-108" />
      <BedtimeDread data-id="element-109" />
      <WhyAdviceFails data-id="element-110" />
      <StabilizationLadder data-id="element-111" />
      <WhatYouGet data-id="element-112" />
      <WhatChanges data-id="element-113" />
      <QuietPromise data-id="element-114" />
      <FAQSection data-id="element-115" />
      <CTASection data-id="element-116" />
      <Footer onNavigate={onNavigate} data-id="element-117" />
      <FloatingCTA data-id="element-118" />
    </div>;
}